import { render, staticRenderFns } from "./VariableAgainstAnother.vue?vue&type=template&id=1ef35020&"
import script from "./VariableAgainstAnother.vue?vue&type=script&lang=js&"
export * from "./VariableAgainstAnother.vue?vue&type=script&lang=js&"
import style0 from "./VariableAgainstAnother.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports